import App from "./src/App"
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme,ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import store from "./src/stores/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import ErrorBoundary from "./src/components/errors/ErrorBoundary";
import { googleClientId } from "./src/config/oauth";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
const theme = createTheme({
    typography: {
      fontFamily: 'Poppins, sans-serif',
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiInputLabel-root': {
              fontFamily: 'Poppins, sans-serif',
              fontSize: '15px',
              fontWeight: 'bold',
            },
            '& .MuiInputBase-root': {
              fontFamily: 'Poppins, sans-serif',
              fontSize: '15px',
              fontWeight: 'bold',
            },
            '& .MuiFormHelperText-root': {
              fontFamily: 'Poppins, sans-serif',
              fontSize: '15px',
              fontWeight: 'bold',
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: 'red',
          },
        },
      },
    },
  });

if(document.getElementById('root')){
    const appContent = (
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    );

    ReactDOM.createRoot(document.getElementById('root')).render(
        <ErrorBoundary>
        <Provider store={store}>
            {googleClientId ? (
                <GoogleOAuthProvider clientId={googleClientId}>
                    {appContent}
                </GoogleOAuthProvider>
            ) : (
                appContent
            )}
        </Provider>
        </ErrorBoundary>
    );
}
